import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/style/reset.css";
import "@/assets/style/global.css";
import "@/assets/style/index.css";
import "@/assets/style/index.less";

import "@/assets/style/public.css";
import "@/helper/registerGlobalComponents.js";
import request from "@/helper/request";
import 'swiper/swiper-bundle.min.css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.isMobile = function() {
  const userAgentInfo = navigator.userAgent;
  const mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  for (let i = 0; i < mobileAgents.length; i++) {
    if (userAgentInfo.indexOf(mobileAgents[i]) > 0) {
      return true; // 是移动设备
    }
  }
  return false; // 是PC设备
};

import vueSwiper from 'vue-awesome-swiper';
Vue.use(vueSwiper);
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.prototype.request = request;
Vue.use(ElementUI);
// Vue.use(VueMeta)


new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
